export async function fetchWpApi(postType, parametor) {
    const domain = window.location.origin;
    const path = "/wp-json/wp/v2/";

    const response = await fetch(`${domain}${path}${postType}?${parametor}`);
    const datas = await response.json();

    if (parametor.includes("&page=")) {
        const totalPage = response.headers.get("x-wp-totalpages");

        return { datas, totalPage };
    }

    return datas;
}
